export default "__VITE_ASSET__BYjSLT8w__"